(function ($) {
    $.YPTC = $.YPTC || {};
    $.YPTC.Delta = $.YPTC.Delta || {};
    $.YPTC.Delta.Report = $.YPTC.Delta.Report || {};
    $.YPTC.Delta.Report.EditLine = $.YPTC.Delta.Report.EditLine || (function () {
        let _report_id = null, _modal = null;
        const
        init = function (reportID) {
            _report_id = reportID;
            let btns = document.querySelectorAll('.layout-report .lnk-edit-line');
            if (btns.length > 0) btns.forEach((b) => b.addEventListener('click', evt_EditLink_Click, false));
        },
        evt_EditLink_Click = function () {
            if (_modal === null) {
                var $tr = $(this).closest('tr');

                $(this).next('.lnk-line-edit-spinner').show();
                $(this).hide();

                var popupTitle = `Edit ${$tr.attr('data-line-type-text')}`;
                var reportLabel = $tr.find('.report-label').find('div').text();
                var lineType = $tr.attr('data-line-type');
                var lineDetailType = $tr.attr('data-line-detail-type');
                var lineIndex = $tr.attr('data-line-index');
                var noDelete = $tr.attr('data-no-delete');

                showModal(popupTitle, reportLabel, lineType, lineDetailType, null, lineIndex, null, noDelete, null);
            }

            return false;
        },
        evt_ShowNbrs_Click = function () {
            let acctList = _modal.querySelector('.line-edit-popup .modal-body .account-list');
            if (acctList !== null) acctList.classList.toggle('show-numbers');
        },
        evt_LabelMode_Click = function() {
            let rdoGrouped = document.getElementById('rdoLinesGrouped');
            let chkWithNbrs = document.getElementById('IncludeAccountNumbers');
            let ctrlWithNbrs = document.getElementById('ctrlWithNbrs');
            let lbl = document.getElementById('txtLineLabel');

            if (rdoGrouped !== null && chkWithNbrs !== null && ctrlWithNbrs !== null && lbl !== null){
                lbl.disabled = !rdoGrouped.checked;
                lbl.value = rdoGrouped.checked ? "" : "N/A";
                chkWithNbrs.disabled = rdoGrouped.checked;
                _modal.querySelector('label[for="IncludeAccountNumbers"]').classList.toggle('muted');

                if (rdoGrouped.checked) { lbl.focus(); lbl.select(); }
                else { lbl.classList.remove('is-invalid'); _modal.querySelector('.account-list').focus(); }
            }
        },
        evt_Account_Click = function (modal) {
            if (this.checked) {
                let lbl = document.getElementById('txtLineLabel'),
                    withAcctNbr = document.getElementById('IncludeAccountNumbers'),
                    rdoIndiv = document.getElementById('rdoLinesIndividual'),
                    useIndividualLines = (rdoIndiv !== null && rdoIndiv.checked);
                if (!useIndividualLines && lbl !== null && withAcctNbr !== null) {
                    if (lbl.value.length === 0) {
                        var nbr = $('.account-number', this.parentElement).text();
                        var txt = $('.account-name', this.parentElement).text();
                        lbl.value = withAcctNbr.checked ? `${nbr} ${txt}` : `${txt}`;
                    }
                }
                else if (!useIndividualLines && lbl !== null) { // dialogs without account numbers (dimensions)
                    if (lbl.value.length === 0) {
                        var txt = $('.account-name', this.parentElement).text();
                        lbl.value = `${txt}`;
                    }
                }
            }
        },
        evt_Save_Click = function (popupTitle, reportLabel, lineType, lineDetailType, addSectionType, lineIndex, afterIndex, noDelete, defaultLabel) {
            waitModal();

            let okValid = validate_Save();
            if (!okValid) return;

            let rid = document.getElementById('ReportID'),
                aidx = document.getElementById('AfterIndex'),
                lidx = document.getElementById('LineIndex'),
                rdo = document.getElementById('rdoLinesIndividual'),
                lbl = document.getElementById('txtLineLabel'),
                type = document.getElementById('AddSectionType'),
                withNbrs = document.getElementById('IncludeAccountNumbers'),
                showNbrs = document.getElementById('ShowAccountNumbers'),
                accts = _modal.querySelectorAll('.line-edit-popup .account-item input[type="checkbox"]:not([hidden]):not([disabled]):checked');

            let data = {
                ReportID: (rid !== null ? parseInt(rid.value) : 0),
                AfterIndex: (aidx !== null && aidx.value.length > 0 ? parseInt(aidx.value) : 0),
                LineIndex: (lidx !== null && lidx.value.length > 0 ? parseInt(lidx.value) : 0),
                Label: (lbl !== null ? lbl.value : 'N/A'),
                Type: (type !== null ? type.value : 'Detail'),
                AddIndividualLines: (rdo !== null ? rdo.checked : false),
                IncludeAccountNumbers: (withNbrs !== null ? withNbrs.checked : false),
                ShowAccountNumbers: (showNbrs !== null ? showNbrs.checked : false),
                Accounts: Array.from(accts).map(a => a.dataset.aid)
            };

            fetch('/report/line', {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            })
            .then((res) => res.json())
            .then(function(json) {
                if (json.ok) location.reload();
                else { alert(json.msg); resetModal(); }
            });
        },
        evt_Delete_Click = function (popupTitle, reportLabel, lineType, lineDetailType, addSectionType, lineIndex, afterIndex, noDelete, defaultLabel) {
            var $main = this; // the main popup
            delta.popup.open({ 
                type: 'confirm',
                title: `Delete ${popupTitle}`,
                cssClass: 'line-delete-popup',
                content: `Are sure you want to delete the line "${reportLabel}" ?`,
                okButtonText: 'Yes, Delete',
                afterOpen: function ($p) {
                    $main.css('opacity', '0.5');  //fade main popup
                    $p.find('.modal-footer .btn-primary').removeClass('btn-primary').addClass('btn-danger');
                },
                okCallback: function ($p) {
                    waitModal($p);
                    delta.ajax.get(`/report/deleteLine?reportID=${_report_id}&index=${lineIndex}`, 
                        function(res){ if (res.ok) location.reload(); else alert(res.msg);
                    });
                    return false;
                },
                cancelCallback: function ($p) {
                    $main.css('opacity', '1'); //unfade main popup
                    delta.popup.enableButtons( $($main) ); // re-enable buttons on main popup
                }
            })

            return false;
        },
        validate_Save = function(){
            let lbl = document.getElementById('txtLineLabel');
            let rdo = document.getElementById('rdoLinesIndividual');
            let invalidLabel = (
                // require label text when rdoLinesIndividual is not checked
                (rdo !== null && !rdo.checked && lbl !== null && lbl.value.length === 0)
            );

            if (invalidLabel) {
                lbl.classList.add('is-invalid');
                lbl.focus();
                lbl.select();
                return resetModal();
            }

            let accts = _modal.querySelectorAll('.line-edit-popup .account-item input[type="checkbox"]:checked');
            let ctrl = document.getElementById('ctrlAccounts');

            if (ctrl !== null){
                if (accts.length == 0) {
                    ctrl.classList.add('red');
                    ctrl.querySelector('.invalid-feedback').classList.add('d-block');
                    return resetModal();
                }
                else {
                    ctrl.classList.remove('red');
                    ctrl.querySelector('.invalid-feedback').classList.remove('d-block');
                }
            }

            return true;
        },
        model_Opened = function ($m, noDelete, defaultLabel) {
            _modal = $m.get(0);

            let showNbrs = document.getElementById('ShowAccountNumbers');
            let acctList = _modal.querySelector('.modal-body .account-list');

            if (showNbrs !== null && acctList !== null) {
                if (showNbrs.checked) acctList.classList.add('show-numbers');
                else acctList.classList.remove('show-numbers');
            }

            let rdoLabelModes = _modal.querySelectorAll('#rdoLinesGrouped, #rdoLinesIndividual'),
                chkShowNbr = document.getElementById('ShowAccountNumbers'),
                cblAccounts = _modal.querySelectorAll('.account-list input[type="checkbox"]:not(:disabled)');

            rdoLabelModes.forEach((rdo) => rdo.addEventListener('click', evt_LabelMode_Click));
            if (chkShowNbr != null) chkShowNbr.addEventListener('click', evt_ShowNbrs_Click);
            if (cblAccounts != null) cblAccounts.forEach((chk) => chk.addEventListener('click', evt_Account_Click));

            let lbl = document.getElementById('txtLineLabel');
            if (lbl !== null){
                if (defaultLabel) lbl.value = defaultLabel;
                lbl.focus(); 
            }
        },
        waitModal = function(){
            $('.modal-footer button', _modal).first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
        },
        resetModal = function () {
            let spin = _modal.querySelector('.line-edit-popup .modal-footer .fa-spinner');
            if (spin !== null) spin.remove();
            delta.popup.enableButtons( $(_modal) );
            return false;
        },
        showModal = function (popupTitle, reportLabel, lineType, lineDetailType, addSectionType, lineIndex, afterIndex, noDelete, defaultLabel) {
            let buttons = [
                { text: 'Cancel', callback: function(m) { _modal = null; delta.popup.close(m); } },
                { text: 'Save', isPrimary: true, cssClass: 'isSave', callback: function(m) { evt_Save_Click.apply(m, args); } }
            ];

            if (noDelete === 'false' || noDelete === false) buttons.push( // add optional button
                { text: 'Delete', leftAlign: true, cssClass: 'isDelete', callback: function(m) { evt_Delete_Click.apply(m, args); } }
            );

            let args = arguments;
            delta.ajax.get(`/report/line?reportID=${_report_id}&lineType=${lineType}&lineDetailType=${lineDetailType}&addSectionType=${addSectionType}&lineIndex=${lineIndex ?? -1}&afterIndex=${afterIndex ?? -1}`,
                function (res) {
                    delta.popup.open({
                        type: 'generic',
                        title: `${popupTitle}: ${reportLabel}`,
                        content: res,
                        cssClass: 'line-edit-popup modal-lg',
                        afterOpen: (m) => model_Opened(m, noDelete, defaultLabel),
                        buttons: buttons
                    });
                }
            );
        };

        return { Init:init, Show:showModal };
    })();
})(jQuery);